<template>
  <div class="kt-widget17">
    <div class="kt-widget17__item">
      <span class="kt-widget17__icon">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'kt-svg-icon kt-svg-icon--brand'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M5 3h1a1 1 0 011 1v16a1 1 0 01-1 1H5a1 1 0 01-1-1V4a1 1 0 011-1zm5 0h1a1 1 0 011 1v16a1 1 0 01-1 1h-1a1 1 0 01-1-1V4a1 1 0 011-1z" fill="#000"/><rect fill="#000" opacity=".3" transform="rotate(-19 17.826 11.946)" x="16.326" y="2.946" width="3" height="18" rx="1"/></g></svg>
      </span>
      <span class="kt-widget17__subtitle">
        Delivered
      </span>
      <span class="kt-widget17__desc">
        15 New Paskages
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: "test",
  data() {
    return {
      showImageEditor: false
    };
  },
  methods: {
    loadImageEditor() {
      // let imgUrl = "http://localhost:3000/uploads/sample.png";
    },
    resetImageEditor() {},
    saveImageEditor() {},
    closeForm() {
      this.showImageEditor = false;
    }
  }
};
</script>
<style scoped></style>
